import type { ProductOnboardingCheckResponse } from '../types';

export const AddTrialApi = Symbol.for('AddTrialApi');

/**
 * 添加试用权限的参数
 */
export interface AddFreePkgParams {
    /** 权限类型 ('AIR' | 'LS' | 'INSIGHTS') */
    empowerType: string;
    /** 来源标识 */
    from?: string;
    /** 扩展参数体 https://confluence.zhihuiya.com/pages/viewpage.action?pageId=272192900 */
    extendBody?: Record<string, any>;
}

/**
 * Add Trial API
 * 处理试用权限添加相关的接口调用
 */
export interface AddTrialApi {
    /**
     * 产品准入检查
     *
     * 对应后端 `/account-privilege/product-onboarding/check` 接口，替代旧版 `need-add-trial`。
     * 返回准入决策动作类型，由调用方据此分发后续流程。命中
     * `grant_individual_tenant_privilege` 时后端已在本次请求中完成赋权。
     *
     * @param empowerType - 权限类型 ('AIR' | 'LS' | 'INSIGHTS')
     * @param extendBody - 扩展参数体
     * @returns 产品准入决策结果，包含 `action_type`
     */
    checkProductOnboarding(empowerType: string, extendBody: Record<string, any>): Promise<ProductOnboardingCheckResponse>;

    /**
     * 添加试用权限
     * @param params - 添加试用权限的参数
     */
    addFreePkg(params: AddFreePkgParams): Promise<void>;
}
